var _path, _g, _path2, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeoPlacemark = function SvgGeoPlacemark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64003C",
    d: "M16.82 24.044c3.427-6.376 7.385-9.384 13.71-9.384s8.169 5.48 4.407 9.384c-5.631 5.845-16.077 7.297-18.607 7.297s-3.3-.246.49-7.297",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#geoPlacemark_svg__a)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A80064",
    d: "M16.243 24.044C18.914 17.668 22 14.66 26.929 14.66s6.368 5.48 3.435 9.384c-4.389 5.845-12.53 7.297-14.503 7.297-1.972 0-2.572-.246.382-7.297"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#EB008C",
    strokeWidth: 2,
    d: "M4.75 14.486c0-6.458 5.167-10.979 11.625-10.979S28 8.028 28 14.487c0 10.141-9.042 14.853-11.625 14.853S4.75 24.628 4.75 14.486Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.375,
    cy: 14.424,
    r: 5.22,
    fill: "#EB008C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "geoPlacemark_svg__a",
    width: 29.671,
    height: 28.681,
    x: 8.204,
    y: 8.66,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_10144_5053",
    stdDeviation: 3
  })))));
};
export default SvgGeoPlacemark;